export const HERO_CARDS = [
  { id: 'setup', label: 'Dragon setup' },
  { id: 'mic', label: 'Dragon mic setup' },
  { id: 'ui', label: 'Failed to launch UI' },
  { id: 'install', label: 'Installation problems' },
  { id: 'error', label: 'Dragon Error Code' },
];

export const PRODUCTS = [
  {
    id: 'pro-15',
    name: 'Dragon Professional Individual v15',
    blurb: 'Full-featured dictation for Windows power users who need accurate voice typing and custom commands at work.',
    image: '/images/product-pro.jpg',
    rating: 5,
    priceWas: 699,
    priceNow: 549,
  },
  {
    id: 'legal-15',
    name: 'Dragon Legal Individual v15 — Upgrade',
    blurb: 'Legal vocabulary and clause-friendly workflows so attorneys can draft, revise, and file without slow keyboard work.',
    image: '/images/product-legal.jpg',
    rating: 5,
    priceWas: 799,
    priceNow: 629,
  },
  {
    id: 'medical-16',
    name: 'Dragon Medical Practice Edition',
    blurb: 'Clinical speech recognition tuned for EHR notes, charts, and specialty terms used in busy practices.',
    image: '/images/product-medical.jpg',
    rating: 5,
    priceWas: 1699,
    priceNow: 1499,
  },
  {
    id: 'home-15',
    name: 'Dragon Home Edition v15',
    blurb: 'Straightforward home dictation for email, documents, and everyday PC control with a lighter feature set.',
    image: '/images/product-home.jpg',
    rating: 4,
    priceWas: 229,
    priceNow: 179,
  },
];

export const STATS = [
  { value: '15+', label: 'Years experience' },
  { value: '220+', label: 'Certified agents' },
  { value: '8,500+', label: 'Satisfied clients' },
  { value: '40k+', label: 'Support sessions' },
];

export const FAQS = [
  {
    q: 'What is Dragon software, and how does it work?',
    a: 'Dragon NaturallySpeaking turns your spoken words into text and computer commands. After a short voice profile setup, you dictate into documents, email, and many Windows apps while our team helps tune accuracy and microphone settings.',
  },
  {
    q: 'Do you provide free technical support for Dragon products?',
    a: 'Yes. Dragon Help offers complimentary guidance for setup, mic configuration, installation failures, activation issues, and common error codes. Complex recovery work can be quoted if hardware or OS repair is required.',
  },
  {
    q: 'Which Dragon versions do you support?',
    a: 'We support current and recent Dragon Home, Professional, Legal, and Medical releases on supported Windows systems. Share your exact version and Windows build so we can match the right fix path.',
  },
  {
    q: 'Can you help if Dragon fails to launch or shows an error code?',
    a: 'Absolutely. Failed UI launches, mic recognition problems, and numbered error codes are among our most common tickets. Call or message us with the exact message on screen and we will walk you through the repair steps.',
  },
];
